import _ from "@lodash";
import { Avatar, Paper, Typography } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import CustomFields from "app/Core/Components/CustomFields/CustomFields";
import EmpresaPessoaToggleButton from "app/ERP/EmpresaPessoa/Components/EmpresaPessoaToggleButton";
import { showMessage } from "app/store/actions";
import withReducer from "app/store/withReducer";
import clsx from "clsx";
import dayjs from "dayjs";
import MobileDetect from "mobile-detect";
import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { MdMail, MdPhone, MdPhoneAndroid } from "react-icons/md";
import { RiCake2Line } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import TagBullet from "../TagBullet/TagBullet";
import { list, save } from "./Store/Actions/CustomCrmFormActions";
import Reducer from "./Store/Reducers";

const md = new MobileDetect(window.navigator.userAgent);

function CustomCrmForm(props) {

   const { xappRouteParams, data = {}, settings } = props;
   const dispatch = useDispatch();
   const [form, setForm] = useState(data.dadoscrm ?? {});
   const reducer = useSelector(({ Reducer }) => Reducer.CustomCrmFormReducer);
   const tags = useSelector(({ Reducer }) => Reducer.TagFuncionalidadeReducer["pessoa"]) ?? null;

   useEffect(() => {
      if (_.isNull(tags)) {
         dispatch(list(xappRouteParams));
      }
   });

   useEffect(() => {
      if (reducer.info) {
         dispatch(showMessage({ message: reducer.info, variant: "success" }));
         reducer.info = null;
      }
      if (reducer.error) {
         dispatch(showMessage({ message: reducer.error, variant: "error" }));
         reducer.error = null;
      }
   }, [reducer]);

   const AGrupos = settings.sistemas[xappRouteParams.empresa]?.grupos ?? "";
   let ADateSplit = [];
   if (!_.isNull(data) && !_.isNull(data.nascimentoabertura) && !_.isUndefined(data.nascimentoabertura)) {
      ADateSplit = data.nascimentoabertura.split("/");
   }

   function saveForm() {
      let AForm = { idpessoaformulario: data.idpessoaformulario, dadoscrm: form };
      dispatch(save(AForm, xappRouteParams));
   }

   function getTags() {
      let AResponse = [];
      if (!_.isNull(tags) && tags.length > 0 && !_.isUndefined(data.tags) && !_.isNull(data.tags)) {
         tags.forEach(tag => {
            if (data.tags.includes(tag.codigo)) {
               AResponse.push({ "id": tag.idtagpessoaformulario, "title": tag.tagnome, "color": tag.cor });
            }
         });
      }
      return AResponse;
   }

   return (
      <div className="p-24">
         <Paper className={clsx("flex flex-col items-center justify-center w-full md:justify-start mt-8")}>
            <div className="w-full flex flex-row h-full items-center p-12">
               <Avatar className="w-96 h-96" src={data.foto ? data.foto : "assets/images/avatars/profile.png"} />
               <div className="flex w-full items-center">
                  <div className="block items-center w-full">
                     <TagBullet
                        className="ml-16 mr-4"
                        itens={getTags()}
                     />
                     <div className="flex flex-row items-center">
                        <Typography className={clsx("ml-16 mr-4")} color="textSecondary">{data.nome}</Typography>
                        {AGrupos.includes("{1}") && // PERMISSÃO DE CADASTRO
                           <EmpresaPessoaToggleButton
                              xappRouteParams={xappRouteParams}
                              idpessoaformulario={data.idpessoaformulario}
                              iconProps={clsx("text-18")}
                           />
                        }
                     </div>
                     <div className="flex flex-row items-center mt-8">
                        {!_.isUndefined(data.nascimentoabertura) && !_.isNull(data.nascimentoabertura) && data.nascimentoabertura !== "" &&
                           <Typography className={clsx("ml-16 mr-4 white")} color="textSecondary">{"Data de nascimento: " + dayjs(data.nascimentoabertura).format("DD/MM/YYYY")}</Typography>
                        }
                        {_.isEqual(new Date().getMonth(), new Date(+ADateSplit[2], ADateSplit[1] - 1, +ADateSplit[0]).getMonth()) &&
                           <RiCake2Line className="text-20 ml-16" />
                        }
                     </div>
                     <div className="flex flex-row items-center mt-8">
                        {!_.isUndefined(data.origem) && !_.isNull(data.origem) && data.origem !== "" &&
                           <Typography className={clsx("ml-16 mr-4 white")} color="textSecondary">
                              {"Origem: " + data.origem + (!_.isNull(data.origemdescricao) && data.origemdescricao !== "" ? (" [ " + data.origemdescricao + " ]") : "")}
                           </Typography>
                        }
                     </div>
                     <div className="flex flex-wrap w-full mx-8 mt-6">
                        {data.fone && data.fone.length > 3 &&
                           <a
                              style={{ textDecoration: "none" }}
                              className="font-medium flex items-center p-4"
                              href={"tel:" + data.fone}
                              target="_blank"
                              rel="noopener noreferrer"
                           >
                              <MdPhone className="text-green text-20 mr-8" />
                              <Typography className="text-14 xs:hidden sm:block whitespace-no-wrap mr-8" color="textSecondary">{data.fone}</Typography>
                           </a>
                        }
                        {data.celular && data.celular.length > 3 &&
                           <a
                              style={{ textDecoration: "none" }}
                              className="font-medium flex items-center p-4"
                              href={"tel:" + data.celular}
                              target="_blank"
                              rel="noopener noreferrer"
                           >
                              <MdPhoneAndroid className="text-green text-20 mr-8" />
                              <Typography className="text-14 xs:hidden sm:block whitespace-no-wrap mr-8" color="textSecondary">{data.celular}</Typography>
                           </a>
                        }
                        {data.whatsapp && data.whatsapp.length > 3 &&
                           <a
                              style={{ textDecoration: "none" }}
                              className="font-medium flex items-center p-4"
                              href={"https://wa.me/" + data.whatsapp}
                              target="_blank"
                              rel="noopener noreferrer"
                           >
                              <FaWhatsapp className="text-green text-20 mr-8" />
                              <Typography className="text-14 xs:hidden sm:block whitespace-no-wrap mr-8" color="textSecondary">{data.whatsapp}</Typography>
                           </a>
                        }
                        {data.email && data.email.length > 0 &&
                           <a
                              style={{ textDecoration: "none" }}
                              className="font-medium flex items-center p-4"
                              href={"mailto:" + data.email}
                              target="_blank"
                              rel="noopener noreferrer"
                           >
                              <MdMail className="text-yellow-dark text-20 mr-8" />
                              <Typography className="text-14 xs:hidden sm:block whitespace-no-wrap mr-8" color="textSecondary">{data.email}</Typography>
                           </a>
                        }
                     </div>
                  </div>
               </div>
            </div>
         </Paper>
         <CustomFields
            xappRouteParams={xappRouteParams}
            tipo={"cliente-crm"}
            formulario={form}
            onChange={ev => setForm(_.set({ ...form }, ev.target.name, ev.target.value))}
         />
         <React.Fragment>
            <div className="flex justify-end px-12">
               <XAPPButton
                  type="Button"
                  className=""
                  onClick={() => saveForm()}
                  variant="contained"
                  color="primary"
                  iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                  icon={"save"}
                  label={"Salvar"}
                  key={"SalvarFormCrm"}
               />
            </div>
         </React.Fragment>
      </div>
   );
}

export default withReducer("Reducer", Reducer)(withRouter(CustomCrmForm));
